import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(): Promise<Optional<Role[]>> {
	const url: string = `${SERVICEBASEURL.USER}/Role`;
	return axios.get(url).toOptionalMapped((x) => x.data.roles);
}

export interface Response {
	data: ResponseData;
}

export interface ResponseData {
	roles: Role[];
}

export type Role = {
	id: string;
	name: string;
};
